var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPantsMen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.824 5a.91.91 0 00-.81.906v8.007a.927.927 0 000 .314v.252a.908.908 0 00.54.827L8.66 22.7a.91.91 0 001.026.47h8.617a.91.91 0 001.028-.47l4.106-7.382a.909.909 0 00.549-.834v-.264a.902.902 0 000-.31V5.906a.91.91 0 00-.913-.905H4.824zM5.88 6.852h16.237v.906H5.88v-.906zm15.38 8.65l-2.909 5.227c-.393-.736-.721-1.625-.721-2.09 0-.997.478-1.727 1.368-2.315.598-.395 1.392-.673 2.262-.821zm-14.512.021c.837.155 1.611.426 2.203.808.92.593 1.414 1.324 1.414 2.307 0 .417-.349 1.279-.762 2.018l-2.855-5.133z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgPantsMen;